import { __ } from "@wordpress/i18n";
import {
  InspectorControls,
  __experimentalSpacingSizesControl as SpacingSizesControl,
} from "@wordpress/block-editor";
import {
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
  ToggleControl,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from "@wordpress/components";

import DefaultStateSettings from "./DefaultStateSettings";
import AddedStateSettings from "./AddedStateSettings";
import DefaultStateStyleSettings from "./DefaultStateStyleSettings";
import AddedStateStyleSettings from "./AddedStateStyleSettings";
import HoverStateStyleSettings from "./HoverStateStyleSettings";
import "./index.scss";

export default function AllInspectorSettings({
  attributes,
  setAttributes,
  displayState,
  setDisplayState,
}) {
  const { useIcon = true, iconGap = "4px", iconPosition = "left" } = attributes;

  return (
    <>
      <InspectorControls>
        <ToolsPanel label={__("Settings")}>
          <ToolsPanelItem
            hasValue={() => useIcon !== true}
            label={__("Use icon", "brandy-blocks")}
            onDeselect={() => setAttributes({ useIcon: true })}
            isShownByDefault
          >
            <ToggleControl
              label={__("Use icon", "brandy-blocks")}
              checked={useIcon}
              onChange={(value) => setAttributes({ useIcon: value })}
            />
          </ToolsPanelItem>
          <ToolsPanelItem
            hasValue={() => iconPosition !== "left"}
            label={__("Icon position", "brandy-blocks")}
            onDeselect={() => setAttributes({ iconPosition: "left" })}
            isShownByDefault
          >
            <ToggleGroupControl
              value={iconPosition}
              onChange={(value) => setAttributes({ iconPosition: value })}
              isBlock
              label={__("Icon position", "brandy-blocks")}
              __nextHasNoMarginBottom
              __next40pxDefaultSize
            >
              <ToggleGroupControlOption
                value="left"
                label={__("Left", "brandy-blocks")}
              />
              <ToggleGroupControlOption
                value="right"
                label={__("Right", "brandy-blocks")}
              />
            </ToggleGroupControl>
          </ToolsPanelItem>
          <ToolsPanelItem
            hasValue={() => iconGap !== "4px"}
            label={__("Icon gap", "brandy-blocks")}
            onDeselect={() => setAttributes({ iconGap: "4px" })}
            isShownByDefault
          >
            <SpacingSizesControl
              label={__("Icon gap", "brandy-blocks")}
              min={0}
              value={iconGap}
              onChange={(value) => setAttributes({ iconGap: value.top })}
              showSideInLabel={false}
              sides={["top"]}
              values={{ top: iconGap }}
              allowReset={false}
            />
          </ToolsPanelItem>
          <div className="components-base-control" style={{ gridColumn: "1/-1" }}>
            <ToggleGroupControl
              value={displayState}
              onChange={(value) => setDisplayState(value)}
              isBlock
              label={__("View display state", "brandy-blocks")}
              __nextHasNoMarginBottom
              __next40pxDefaultSize
            >
              <ToggleGroupControlOption
                value="default"
                label={__("Default", "brandy-blocks")}
              />
              <ToggleGroupControlOption
                value="added"
                label={__("Added", "brandy-blocks")}
              />
            </ToggleGroupControl>
          </div>
        </ToolsPanel>
        <DefaultStateSettings
          attributes={attributes}
          setAttributes={setAttributes}
        />
        <AddedStateSettings
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </InspectorControls>
      <InspectorControls group="styles">
        <DefaultStateStyleSettings
          attributes={attributes}
          setAttributes={setAttributes}
        />
        <HoverStateStyleSettings
          attributes={attributes}
          setAttributes={setAttributes}
        />
        <AddedStateStyleSettings
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </InspectorControls>
    </>
  );
}
